import classNames from 'classnames';
import { FC } from 'react';

type CurrencyFlagProps = Readonly<{
  className?: string;
  currency: string;
  size?: 'sm' | 'lg' | 'xl';
}>;

export const CurrencyFlagIcon: FC<CurrencyFlagProps> = ({ className, currency, size }) => (
  <div
    className={classNames(
      'currency-flag',
      `currency-flag-${currency.toLowerCase()}`,
      size !== undefined ? `currency-flag-${size}` : undefined,
      className,
    )}
  />
);
